import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ShareContestPage } from 'src/app/contest-listing/share-contest/share-contest.page';
@Component({
  selector: 'app-gameon',
  templateUrl: './gameon.page.html',
  styleUrls: ['./gameon.page.scss'],
})
export class GameonPage implements OnInit, OnDestroy {
  @Input() matchDetails;
  @Input() matchId;
  @Input() contestId;
  @Input()sharecode;
  language: string;
  constructor(
    private router: Router,
    private model: ModalController,
    private translate: TranslateService,
    public modelCtrl: ModalController,
  ) { }
  ionViewWillEnter() {
    console.log("run on ionic oninit");
    this.language = localStorage.getItem("language");
    if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }
}
  ngOnInit() {
    console.log(this.matchId);
    console.log(this.contestId);
    // console.log(this.sharecode);
    // if(this.sharecode){
    //   this.shareContestModel(this.contestId, this.matchId)
    // }
  }
  myTeams() {
    this.router.navigate(['mycontest'], { queryParams: { matchDetails: JSON.stringify(this.matchDetails) } });
    this.model.dismiss();
  }
  joinContest() {
    this.router.navigate(['contest-listing'], { queryParams: { matchDetails: JSON.stringify(this.matchDetails) } });
    this.model.dismiss();
  }
  async shareContestModel(contestId, matchId) {
    //console.log("contestId", contestId);
    // event.stopPropagation();
    const model = await this.modelCtrl.create({
      component: ShareContestPage,
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: 'modal-class-share-contest',
      //data pass 
      componentProps: { contestId: contestId, matchId: matchId }
    });
    model.onDidDismiss();
    await model.present();
  }

  ngOnDestroy() {

  }
}
